import lang from '../lang/index';

module.exports = function(time) {
    var now = new Date().getTime();
    var t;
    if (typeof time == 'number') {
        t = new Date(parseInt(time));
    } else if (typeof time == 'string') {
        t = Number(time) ? arguments.callee(parseInt(time)) : new Date(time.replace(/-/g, '/'));
    }
    var val = Math.floor((now - t) / 1000);
    var result = '';
    var timeMap = {
        'y': {
            rate: 60 * 60 * 24 * 365
        },
        'M': {
            rate: 60 * 60 * 24 * 30
        },
        'd': {
            rate: 60 * 60 * 24
        },
        'h': {
            rate: 60 * 60
        },
        'm': {
            rate: 60
        }
    };
    for (var i in timeMap) {
        timeMap[i].value = Math.floor(val / timeMap[i].rate);
    }
    if (timeMap['y'].value > 0) {
        result = lang.template('1年前');
    } else if (timeMap['M'].value > 0) {
        result = lang.template('<%=num%>月前', { num: timeMap['M'].value});
    } else if (timeMap['d'].value > 0) {
        result = lang.template('<%=num%>天前', { num: timeMap['d'].value});
    } else if (timeMap['h'].value > 0) {
        result = lang.template('<%=num%>小时前', { num: timeMap['h'].value});
    } else if (timeMap['m'].value > 0) {
        result = lang.template('<%=num%>分钟前', { num: timeMap['m'].value});
    } else {
        result = lang.template('刚刚');
    }
    return result;
}



// WEBPACK FOOTER //
// ./js/base/time.js